<template>
  <div v-if="justify" class="ms-Spinner-wrapper">
    <div :class="classes">
      <div v-if="!!label && label.length" class="ms-Spinner-label">
        {{ label }}
      </div>
    </div>
  </div>
  <div v-else :class="classes">
    <div v-if="!!label && label.length" class="ms-Spinner-label">
      {{ label }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: ''
    },
    justify: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes() {
      const classes = ['ms-Spinner'];
      if (this.size === 'large') {
        classes.push('ms-Spinner--large');
      }
      return classes;
    }
  },
  mounted() {
    var SpinnerElements = document.querySelectorAll('.ms-Spinner');
    for (var i = 0; i < SpinnerElements.length; i++) {
      new fabric['Spinner'](SpinnerElements[i]);
    }
  }
};
</script>

<style lang="scss" scoped>
.ms-Spinner-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
